import { useRef, useState } from "react";
import { ArrowRight } from "lucide-react";
import { DoorHero3D } from "./DoorHero3D";
import { DoorFallback } from "./DoorFallback";
import { EmergentLogo } from "./EmergentLogo";
import { useTitleIntro } from "./useTitleIntro";
import { useTryIt } from "./useTryIt";

export const HERO_TITLE = "Compliance OS for hardware suppliers";

export const Hero = () => {
  const { titleRef, phase, intro } = useTitleIntro();
  const { tryIt, busy } = useTryIt();
  const regionRef = useRef(null);
  const [mode, setMode] = useState("loading");
  const done = phase === "done";

  return (
    <section id="top" className="relative pt-16" data-testid="hero-section" data-intro={phase}>
      <DoorHero3D intro={intro} region={regionRef} onMode={setMode} />
      <div className="pointer-events-none relative mx-auto grid max-w-[1360px] items-center gap-6 px-5 pb-10 pt-10 sm:px-8 lg:grid-cols-12 lg:gap-4 lg:pb-14 lg:pt-6">
        <div className="pointer-events-auto relative z-10 lg:col-span-5">
          <h1
            ref={titleRef}
            className={`font-display text-4xl font-semibold leading-[1.04] tracking-[-0.035em] text-[#292929] transition-opacity duration-300 ease-out sm:text-5xl lg:text-6xl ${done ? "opacity-100" : "opacity-0"}`}
            data-testid="hero-title"
          >
            {HERO_TITLE}
          </h1>
          <div className={`mt-10 flex flex-col items-start gap-4 transition-[opacity,transform] delay-150 duration-500 ease-out sm:flex-row sm:items-center sm:gap-6 ${done ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-2 opacity-0"}`}>
            <button type="button" onClick={tryIt} disabled={busy} className="cd-btn-primary group h-12 px-7 text-[15px]" data-testid="hero-try-it-button" tabIndex={done ? 0 : -1}>
              Try it
              <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" />
            </button>
            <a href="https://emergent.sh" target="_blank" rel="noopener noreferrer" className="group inline-block whitespace-nowrap" tabIndex={done ? 0 : -1} data-testid="hero-powered-by-link">
              <span className="text-[13px] text-[#8a8a82] transition-colors group-hover:text-[#55554f]">Proudly powered by</span>
              <EmergentLogo height={18} className="ml-1.5 transition-opacity group-hover:opacity-80" />
            </a>
          </div>
        </div>
        <div ref={regionRef} className="relative h-[440px] sm:h-[520px] lg:col-span-7 lg:h-[640px]" data-testid="hero-door-region">
          {mode === "fallback" && <DoorFallback />}
        </div>
      </div>
    </section>
  );
};
